// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__-p3e6","btn":"styles_btn__337ds","tags":"styles_tags__EJHvh","input":"styles_input__1X1Xm","select":"styles_select__kOai4","label":"styles_label__X69T9"};